import type {
    UTCalendarEventFeatureAction,
    UTCalendarUIContext,
    UTCalendarOrigin,
} from '@outlook/unified_telemetry';
import type { MailboxInfo } from 'owa-client-types';
import { getMailCategorizeCallbacks } from 'owa-calendar-unified-telemetry-utils/lib/utils/logMailCategorizeTelemetry';

export default async function executeCategorizeActionWithTelemetry(
    action: UTCalendarEventFeatureAction,
    uiContext: UTCalendarUIContext,
    origin: UTCalendarOrigin,
    mailboxInfo: MailboxInfo,
    operation: (onOperationError: () => void) => Promise<void>
): Promise<void> {
    const { onSuccess, onError } = getMailCategorizeCallbacks(
        action,
        uiContext,
        origin,
        mailboxInfo
    );
    let operationFailed = false;
    try {
        await operation(() => {
            operationFailed = true;
        });
        if (operationFailed) {
            onError();
        } else {
            onSuccess();
        }
    } catch {
        onError();
    }
}
